import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TipComplianceChecker from "./TipComplianceChecker";

const GUMROAD_URL = "https://kevinmcgill6.gumroad.com/l/kteozj";

const DARK = {
  pageBg: "#0D1321", navBg: "#080E1A", border: "#1E293B",
  cardBg: "#0F1623", ctaBg: "linear-gradient(135deg,#1a1f35,#141B2D)",
  ctaBorder: "#2D3748", t1: "#F8FAFC", t2: "#94A3B8", t3: "#64748B",
  t4: "#475569", t5: "#334155", inputBg: "#141B2D", inputBorder: "#2D3748",
};
const LIGHT = {
  pageBg: "#F8FAFC", navBg: "#FFFFFF", border: "#E2E8F0",
  cardBg: "#FFFFFF", ctaBg: "linear-gradient(135deg,#EFF6FF,#F1F5F9)",
  ctaBorder: "#CBD5E1", t1: "#0F172A", t2: "#475569", t3: "#64748B",
  t4: "#94A3B8", t5: "#CBD5E1", inputBg: "#FFFFFF", inputBorder: "#CBD5E1",
};

const getS = (c) => ({
  page: { minHeight: "100vh", background: c.pageBg, fontFamily: "'Syne', sans-serif" },
  nav: { background: c.navBg, borderBottom: `1px solid ${c.border}`, position: "sticky", top: 0, zIndex: 100 },
  navInner: { maxWidth: 1100, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 56 },
  logo: { display: "flex", alignItems: "center", gap: 10, textDecoration: "none" },
  logoMark: { width: 28, height: 28, background: "linear-gradient(135deg,#F59E0B,#D97706)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 },
  logoText: { fontSize: 14, fontWeight: 800, color: c.t1, letterSpacing: "0.02em" },
  logoDot: { color: "#F59E0B" },
  navRight: { display: "flex", alignItems: "center", gap: 16 },
  backLink: { fontSize: 12, fontWeight: 500, color: c.t3, fontFamily: "'IBM Plex Mono', monospace", textDecoration: "none", display: "flex", alignItems: "center", gap: 6 },
  toggleBtn: { background: "none", border: `1px solid ${c.border}`, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 15, color: c.t2, display: "flex", alignItems: "center", justifyContent: "center" },
  wrap: { maxWidth: 1100, margin: "0 auto", padding: "0 24px 80px" },
  hero: { padding: "48px 0 40px", borderBottom: `1px solid ${c.border}`, marginBottom: 40 },
  eyebrow: { display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 20, padding: "5px 14px", marginBottom: 20 },
  eyebrowDot: { width: 6, height: 6, background: "#F59E0B", borderRadius: "50%" },
  eyebrowText: { fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#F59E0B", fontFamily: "'IBM Plex Mono', monospace" },
  h1: { fontSize: "clamp(26px, 4.5vw, 42px)", fontWeight: 800, color: c.t1, margin: "0 0 16px", lineHeight: 1.15 },
  h1Accent: { color: "#F59E0B" },
  lead: { fontSize: 15, color: c.t2, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1.75, maxWidth: 680, margin: "0 0 32px" },
  rateRow: { display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 8 },
  rateCard: { background: c.cardBg, border: `1px solid ${c.border}`, borderRadius: 10, padding: "14px 18px", minWidth: 160, flex: "1 1 160px" },
  rateLabel: { fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: c.t4, fontFamily: "'IBM Plex Mono', monospace", marginBottom: 6 },
  rateVal: { fontSize: 22, fontWeight: 800, color: "#F59E0B", lineHeight: 1, marginBottom: 2 },
  rateSub: { fontSize: 10, color: c.t4, fontFamily: "'IBM Plex Mono', monospace" },
  cols: { display: "grid", gridTemplateColumns: "1fr 320px", gap: 24, alignItems: "start" },
  sidebar: { position: "sticky", top: 72 },
  ctaCard: { background: c.ctaBg, border: `1px solid ${c.ctaBorder}`, borderRadius: 14, padding: "24px", marginBottom: 16 },
  ctaBadge: { display: "inline-flex", alignItems: "center", gap: 6, background: "rgba(245,158,11,0.1)", border: "1px solid rgba(245,158,11,0.25)", borderRadius: 20, padding: "4px 12px", marginBottom: 16, fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#F59E0B", fontFamily: "'IBM Plex Mono', monospace" },
  ctaTitle: { fontSize: 17, fontWeight: 800, color: c.t1, lineHeight: 1.3, marginBottom: 12 },
  ctaDesc: { fontSize: 12, color: c.t3, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1.7, marginBottom: 20 },
  ctaList: { listStyle: "none", padding: 0, margin: "0 0 20px", display: "flex", flexDirection: "column", gap: 8 },
  ctaListItem: { display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12, color: c.t2, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1.5 },
  ctaCheck: { color: "#10B981", fontWeight: 700, flexShrink: 0, marginTop: 1 },
  ctaPrice: { display: "flex", alignItems: "baseline", gap: 6, marginBottom: 16 },
  ctaPriceVal: { fontSize: 32, fontWeight: 800, color: c.t1 },
  ctaPriceSub: { fontSize: 12, color: c.t4, fontFamily: "'IBM Plex Mono', monospace" },
  ctaBtn: { display: "block", width: "100%", padding: "14px", background: "#F59E0B", color: "#0D1321", fontSize: 14, fontWeight: 800, fontFamily: "'Syne', sans-serif", letterSpacing: "0.02em", textAlign: "center", textDecoration: "none", borderRadius: 8, transition: "background 0.15s, transform 0.15s", cursor: "pointer", border: "none" },
  ctaNote: { fontSize: 10, color: c.t4, fontFamily: "'IBM Plex Mono', monospace", textAlign: "center", marginTop: 10, lineHeight: 1.6 },
  seoBlock: { background: c.cardBg, border: `1px solid ${c.border}`, borderRadius: 14, padding: "28px", marginTop: 24 },
  seoH2: { fontSize: 16, fontWeight: 700, color: c.t2, marginBottom: 16, letterSpacing: "0.02em" },
  seoP: { fontSize: 13, color: c.t3, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1.8, marginBottom: 14 },
  seoH3: { fontSize: 13, fontWeight: 700, color: c.t2, marginBottom: 8, marginTop: 20, fontFamily: "'IBM Plex Mono', monospace", letterSpacing: "0.05em", textTransform: "uppercase" },
  footer: { borderTop: `1px solid ${c.border}`, padding: "32px 24px", maxWidth: 1100, margin: "0 auto" },
  footerText: { fontSize: 11, color: c.t4, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1.7, margin: 0 },
  moreToolsCard: { background: c.cardBg, border: `1px solid ${c.border}`, borderRadius: 14, padding: "20px" },
  moreToolsLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: c.t4, fontFamily: "'IBM Plex Mono', monospace", marginBottom: 14 },
  moreToolsLink: { display: "block", fontSize: 12, color: c.t3, fontFamily: "'IBM Plex Mono', monospace", textDecoration: "none", padding: "7px 0", borderBottom: `1px solid ${c.border}` },
});

const RATES = [
  { label: "Statewide", name: "Maryland", min: "$15.00", tip: "$3.63", credit: "$11.37" },
  { label: "Montgomery County", name: "Montgomery Co.", min: "$17.15", tip: "$4.00", credit: "$13.15" },
  { label: "Prince George's County", name: "PG County", min: "$16.70", tip: "$4.00", credit: "$12.70" },
  { label: "Howard County", name: "Howard Co.", min: "$16.00", tip: "$4.00", credit: "$12.00" },
  { label: "Baltimore City", name: "Baltimore City", min: "$15.00", tip: "$3.63", credit: "$11.37" },
];

const BUNDLE_FEATURES = [
  "Meal & rest break requirements by county",
  "Maryland Healthy Working Families Act (sick leave)",
  "Tip pooling rules & documentation templates",
  "Anti-harassment policy & reporting procedures",
  "New hire onboarding checklist & required posters",
  "Youth employment permits & hour restrictions",
  "Montgomery County & PG County local ordinances",
  "Bilingual English/Spanish employee-facing notices",
  "Updated to April 2026 Maryland standards",
];

export default function MarylandLanding() {
  const [isDark, setIsDark] = useState(true);
  const c = isDark ? DARK : LIGHT;
  const S = getS(c);

  useEffect(() => {
    document.title = "Maryland Tip Credit Calculator 2026 | WorkplacePrompts.ai";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content",
        "Free Maryland tip credit calculator for 2026. Check cash wage floors, tip credit eligibility, and the 80/20 rule for all Maryland counties including Montgomery County, Prince George's County, Howard County, and Baltimore City."
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.background = c.pageBg;
    return () => { document.body.style.background = ""; };
  }, [isDark, c.pageBg]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .md-back:hover { color: #94A3B8 !important; }
        .md-cta-btn:hover { background: #D97706 !important; transform: translateY(-1px); }
        .md-toggle:hover { opacity: 0.8; }
        @media (max-width: 800px) {
          .md-cols { grid-template-columns: 1fr !important; }
          .md-sidebar { position: static !important; }
        }
      `}</style>

      <div style={S.page}>
        {/* Nav */}
        <nav style={S.nav}>
          <div style={S.navInner}>
            <Link to="/" style={S.logo}>
              <div style={S.logoMark}>⚖️</div>
              <span style={S.logoText}>
                WorkplacePrompts<span style={S.logoDot}>.ai</span>
              </span>
            </Link>
            <div style={S.navRight}>
              <button
                className="md-toggle"
                style={S.toggleBtn}
                onClick={() => setIsDark(!isDark)}
                aria-label="Toggle theme"
              >
                {isDark ? "☀️" : "🌙"}
              </button>
              <Link to="/" className="md-back" style={S.backLink}>
                ← All Tools
              </Link>
            </div>
          </div>
        </nav>

        <div style={S.wrap}>
          {/* Hero */}
          <div style={S.hero}>
            <div style={S.eyebrow}>
              <div style={S.eyebrowDot} />
              <span style={S.eyebrowText}>2026 Rate Database · Maryland</span>
            </div>
            <h1 style={S.h1}>
              Maryland Tip Credit<br />
              <span style={S.h1Accent}>Calculator 2026</span>
            </h1>
            <p style={S.lead}>
              Verify cash wage floors, tip credit eligibility, the 80/20 rule, and tip pool
              compliance for Maryland — including county-level overrides for Montgomery County,
              Prince George's County, Howard County, and Baltimore City.
            </p>

            <div style={S.rateRow}>
              {RATES.map((r) => (
                <div key={r.label} style={S.rateCard}>
                  <div style={S.rateLabel}>{r.label}</div>
                  <div style={S.rateVal}>{r.tip}<span style={{ fontSize: 13, color: c.t2 }}>/hr</span></div>
                  <div style={S.rateSub}>Cash wage floor · Min: {r.min} · Credit: {r.credit}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Two-column layout */}
          <div className="md-cols" style={S.cols}>
            {/* Left — the tool */}
            <div>
              <TipComplianceChecker defaultState="MD" />

              <div style={S.seoBlock}>
                <h2 style={S.seoH2}>Maryland Tip Credit Law — What Employers Need to Know</h2>
                <p style={S.seoP}>
                  Maryland allows employers to claim a tip credit under the Maryland Wage and Hour Law,
                  but the rules vary significantly by county. The statewide minimum wage is $15.00/hr
                  for 2026, with a tipped employee cash wage floor of $3.63/hr — meaning employers can
                  claim up to $11.37/hr in tip credit per tipped employee, provided that employee's tips
                  actually cover the gap. If they don't, the employer must make up the difference.
                </p>
                <h3 style={S.seoH3}>County-Level Minimum Wages</h3>
                <p style={S.seoP}>
                  Montgomery County has the highest local minimum wage in Maryland at $17.15/hr, with a
                  tipped cash wage floor of $4.00/hr. Prince George's County follows at $16.70/hr. Howard
                  County requires $16.00/hr. Baltimore City matches the statewide rate of $15.00/hr.
                  Employers with operations in multiple counties must apply the rate for the jurisdiction
                  where each employee actually works.
                </p>
                <h3 style={S.seoH3}>The 80/20 Rule in Maryland</h3>
                <p style={S.seoP}>
                  Maryland follows the federal FLSA 80/20 rule. Tipped employees must spend 80% or more
                  of their time on tip-producing work to qualify for the reduced tipped cash wage. If a
                  server spends more than 20% of their shift on non-tipped side work — rolling silverware,
                  cleaning, stocking — the employer cannot claim the tip credit for those hours and must
                  pay the full minimum wage for that time.
                </p>
                <h3 style={S.seoH3}>Tip Pooling Rules</h3>
                <p style={S.seoP}>
                  Maryland permits tip pools among employees who customarily and regularly receive tips.
                  Back-of-house employees (cooks, dishwashers) who do not customarily receive tips cannot
                  participate in a tip pool when the employer is claiming a tip credit. Mandatory service
                  charges are not considered tips under Maryland law and do not count toward satisfying the
                  tip credit.
                </p>
                <h3 style={S.seoH3}>Make-Up Pay Obligation</h3>
                <p style={S.seoP}>
                  If a tipped employee's cash wage plus tips do not equal the applicable minimum wage in
                  any given workweek, Maryland law requires the employer to pay the difference immediately
                  for that workweek. You cannot average tip shortfalls across multiple weeks, and you
                  cannot carry shortfalls forward. The make-up obligation is calculated weekly.
                </p>
              </div>
            </div>

            {/* Right — Sidebar */}
            <div className="md-sidebar" style={S.sidebar}>
              <div style={S.ctaCard}>
                <div style={S.ctaBadge}>📋 Maryland Employers</div>
                <h3 style={S.ctaTitle}>Maryland Food Service HR Compliance Bundle</h3>
                <p style={S.ctaDesc}>
                  18-page compliance guide covering every Maryland employer obligation for food service
                  and restaurant operations — updated to April 2026.
                </p>
                <ul style={S.ctaList}>
                  {BUNDLE_FEATURES.map((f) => (
                    <li key={f} style={S.ctaListItem}>
                      <span style={S.ctaCheck}>✓</span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <div style={S.ctaPrice}>
                  <span style={S.ctaPriceVal}>$67</span>
                  <span style={S.ctaPriceSub}>one-time · instant download</span>
                </div>
                <a
                  href={GUMROAD_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="md-cta-btn"
                  style={S.ctaBtn}
                >
                  Get the Bundle →
                </a>
                <p style={S.ctaNote}>
                  DOCX + PDF included. Instant Gumroad delivery.<br />
                  Not legal advice — for informational use.
                </p>
              </div>

              <div style={S.moreToolsCard}>
                <div style={S.moreToolsLabel}>More Free Tools</div>
                {[
                  { to: "/", label: "🏠 All Compliance Tools" },
                  { to: "/texas", label: "💵 Texas Tip Calculator" },
                  { to: "/florida", label: "💵 Florida Tip Calculator" },
                  { to: "/illinois", label: "💵 Illinois Tip Calculator" },
                  { to: "/new-york", label: "💵 New York Tip Calculator" },
                  { to: "/california", label: "💵 California Tip Rules" },
                  { to: "/dc", label: "💵 Washington D.C. Tip Rules" },
                ].map((l) => (
                  <Link key={l.to} to={l.to} style={S.moreToolsLink}>{l.label}</Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div style={S.footer}>
          <p style={S.footerText}>
            WorkplacePrompts.ai provides free HR compliance research tools for informational purposes only.
            Nothing on this site constitutes legal advice. Maryland wage rates shown reflect 2026 published
            schedules — always verify with the Maryland Department of Labor before taking action. Payroll
            platform links may be affiliate links.
          </p>
        </div>
      </div>
    </>
  );
}
